export default __webpack_public_path__ + "static/heroimg-6c478326ce0a46140a25f609c1bdd4de.png";